import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import TimeLineTileTitle from './TimeLineTileTitle';
import TimeLineTileLists from './TimeLineTileLists';
import MobileTimeLineLists from '../Mobile/TimeLineLists';
import MediaMap from '../Map/MediaMap';
import { deleteRoomByDevice } from '../../actions/api/apis';
import BlackboardListDialog from '../BlackboardList/Dialog';
import * as actionTypes from '../../lib/constants';
import * as action from '../../actions/actionTypes';
import { isGeneral } from '../../lib/tools';

const Main = styled.div`
  flex: 1 0 auto;
  width: 100vw;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
const Contents = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  height: calc(100% - 55px);
  display: flex;
  justify-content: center;
  align-items: stretch;
  @media (max-height: 530px) {
    height: calc(100% - 35px);
  }
`;

// 遠隔作業支援終了処理
const onRemoteSupportEnd = (
  dispatch,
  formatMessage,
  apiToken,
  operatorId,
  deviceId,
) => {
  dispatch({
    type: action.OPEN_USER_PROMPT,
    showUserPrompt: true,
    promptMessage: formatMessage({
      id: 'timeLine.deviceList.remoteSupportEnd.prompt.message',
    }),
    comments: [
      formatMessage({
        id: 'timeLine.deviceList.remoteSupportEnd.prompt.comments.1',
      }),
      formatMessage({
        id: 'timeLine.deviceList.remoteSupportEnd.prompt.comments.2',
      }),
    ],
    buttonArray: [
      { name: formatMessage({ id: 'userPrompt.button.cancel' }) },
      { name: formatMessage({ id: 'userPrompt.button.ok' }) },
    ],
    onAccept: buttonIndex => {
      if (buttonIndex === 1) {
        dispatch(deleteRoomByDevice(apiToken, operatorId, deviceId));
      }
    },
  });
};

const TimeLineTilePage = ({
  match,
  searchBoxHeight,
  userInfo,
  license,
  isMobile,
  operatorWorks,
  currentOperator,
  displayDeviceList,
  displayTimelineList,
  userDevices,
  onSendLocation,
  onDeleteDevice,
  allowRemoteSupport,
  apiToken,
  calendarData,
  onOpenCalendar,
  onCloseCalendar,
  dispatch,
  redirect,
  openDetail,
  timeLineScreenMode,
  executeEvent,
  openUpdateTagsDialog,
  isOpenBlackboardList,
  openBlackboardList,
  targetGroupId,
  innerRole,
  userGroups,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    lists,
    currentPage,
    searchOptions,
    searchOptionsError,
    operatorWorksFullscreenMode,
    checkbox,
  } = operatorWorks;
  const { timelines, totalNumber, totalPages } = lists;
  const pagenation = { totalNumber, totalPages, currentPage };
  const operatorId = (currentOperator && currentOperator.operatorId) || '';
  const isSelfPage = operatorId === userInfo.operatorId;
  const isRemoteOperatorEnabled =
    (userInfo.operatorLicenseInfo &&
      userInfo.operatorLicenseInfo.isRemoteOperatorEnabled) ||
    false;
  const enableRemoteSupport =
    (license.remoteSupport.enabled && isRemoteOperatorEnabled) || false;
  const isRemoteCurrentEnabled =
    (currentOperator.remoteSupportStatus &&
      currentOperator.remoteSupportStatus ===
        actionTypes.REMOTE_SUPPORT_STATUS.enable) ||
    false;
  const enableRemoteButton =
    !isGeneral(innerRole) &&
    enableRemoteSupport &&
    !isSelfPage &&
    isRemoteCurrentEnabled &&
    allowRemoteSupport;
  const fullscreenMap =
    operatorWorksFullscreenMode ===
    actionTypes.TIMELINETILE_FULLSCREEN_MODE.map;
  const defaultDevice = userDevices.filter(device => device.locationInfoOnOff);
  const mediaInfo =
    (defaultDevice.length > 0 && {
      lat: defaultDevice[0].lat,
      lng: defaultDevice[0].lng,
    }) ||
    {};
  const isTimelineTile = !match.url.includes('timelinelist');
  const linkDisplayList = `/ds/timelinelist/${operatorId}`;
  const linkDisplayTile = `/ds/timelinetile/${operatorId}`;
  const previous = isTimelineTile ? linkDisplayTile : linkDisplayList;
  return (
    <Main className="timeLineTilePage">
      {!isMobile && (
        <Contents>
          {isOpenBlackboardList && (
            <BlackboardListDialog
              dispatch={dispatch}
              apiToken={apiToken}
              stringifyOperatorIds={`[${operatorId}]`}
              favoriteId={0}
              onRemoteSupportEnd={deviceId =>
                onRemoteSupportEnd(
                  dispatch,
                  formatMessage,
                  apiToken,
                  operatorId,
                  deviceId,
                )
              }
            />
          )}
          <TimeLineTileTitle />
          <Content>
            {fullscreenMap && (
              <MediaMap
                mediaInfo={mediaInfo}
                fullscreen={fullscreenMap}
                onToggleFullScreen={() =>
                  dispatch({ type: 'CLOSE_DEVICE_LOCATION_MAP' })
                }
              />
            )}
            {!fullscreenMap && (
              <TimeLineTileLists
                noGroupSelected={!targetGroupId}
                searchBoxHeight={searchBoxHeight}
                enableRemoteButton={enableRemoteButton}
                timelines={timelines}
                searchOptions={searchOptions}
                currentOperator={currentOperator}
                pagenation={pagenation}
                onSelect={page => {
                  dispatch({
                    type: 'CHECK_OPERATOR_WORKS_CHECKBOX',
                    value: 'all',
                    checked: false,
                  });
                  dispatch({ type: 'PAGE_OPERATOR_WORKS', page });
                }}
                userDevices={userDevices}
                mediaInfo={mediaInfo}
                userGroups={userGroups}
                operatorWorksFullscreenMode={operatorWorksFullscreenMode}
                onSendLocation={id => onSendLocation(id)}
                onDeleteDevice={id => onDeleteDevice(id)}
                onRemoteSupportEnd={deviceId =>
                  onRemoteSupportEnd(
                    dispatch,
                    formatMessage,
                    apiToken,
                    operatorId,
                    deviceId,
                  )
                }
                onToggleTimelineTile={link => redirect(link)}
                companyLicenseInfo={userInfo.companyLicenseInfo}
                innerRole={innerRole}
                checkbox={checkbox}
                searchOptionsError={searchOptionsError}
                fullscreenMap={fullscreenMap}
                onSearch={option => {
                  dispatch({
                    type: 'UPDATE_OPERATOR_WORKS_SEARCH_OPTIONS',
                    option,
                  });
                }}
                calendarData={calendarData}
                onOpenCalendar={onOpenCalendar}
                onCloseCalendar={onCloseCalendar}
                tags={{}}
                selectedTagIds={[]}
                openDetail={id => openDetail(id, { previous, searchOptions })}
                isTimelineTile={isTimelineTile}
                onToggleMapFullScreen={() =>
                  dispatch({ type: 'OPEN_DEVICE_LOCATION_MAP' })
                }
                onCheckLists={(value, checked) =>
                  dispatch({
                    type: 'CHECK_OPERATOR_WORKS_CHECKBOX',
                    value,
                    checked,
                  })
                }
                onSortLists={sortColumn =>
                  dispatch({ type: 'SORT_OPERATOR_WORKS', sortColumn })
                }
                timeLineScreenMode={timeLineScreenMode}
                executeEvent={executeEvent}
                openUpdateTagsDialog={openUpdateTagsDialog}
                openBlackboardList={id => openBlackboardList(id)}
                targetGroupId={targetGroupId}
                apiToken={apiToken}
                dispatch={dispatch}
              />
            )}
          </Content>
        </Contents>
      )}
      {isMobile && (
        <Contents>
          <MobileTimeLineLists
            userDevices={userDevices}
            timelines={timelines}
            searchOptions={searchOptions}
            currentOperator={currentOperator}
            pagenation={pagenation}
            onSelect={page => dispatch({ type: 'PAGE_OPERATOR_WORKS', page })}
            toggleDeviceList={() =>
              dispatch({ type: 'TOGGLE_MOBILE_DEVICE_LIST' })
            }
            toggleTimeLineList={() =>
              dispatch({ type: 'TOGGLE_MOBILE_TIMELINE_LIST' })
            }
            onSendLocation={id => onSendLocation(id)}
            onDeleteDevice={id => onDeleteDevice(id)}
            displayDeviceList={displayDeviceList}
            displayTimelineList={displayTimelineList}
          />
        </Contents>
      )}
    </Main>
  );
};

TimeLineTilePage.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  searchBoxHeight: PropTypes.number.isRequired,
  userInfo: PropTypes.object.isRequired,
  license: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  operatorWorks: PropTypes.object.isRequired,
  currentOperator: PropTypes.object.isRequired,
  displayDeviceList: PropTypes.bool.isRequired,
  displayTimelineList: PropTypes.bool.isRequired,
  userDevices: PropTypes.array.isRequired,
  onSendLocation: PropTypes.func.isRequired,
  onDeleteDevice: PropTypes.func.isRequired,
  allowRemoteSupport: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  calendarData: PropTypes.object.isRequired,
  onOpenCalendar: PropTypes.func.isRequired,
  onCloseCalendar: PropTypes.func.isRequired,
  openDetail: PropTypes.func.isRequired,
  isOpenBlackboardList: PropTypes.bool.isRequired,
  timeLineScreenMode: PropTypes.number.isRequired,
  executeEvent: PropTypes.string.isRequired,
  openUpdateTagsDialog: PropTypes.bool.isRequired,
  openBlackboardList: PropTypes.func.isRequired,
  targetGroupId: PropTypes.string.isRequired,
  innerRole: PropTypes.number.isRequired,
  userGroups: PropTypes.array.isRequired,
};

export default withRouter(TimeLineTilePage);
